import { atom } from 'jotai';
import { pendoScript } from './pendoScript';
import { pendoApiKeyAtom } from './pendoApiKey';

export const isPendoInitializedAtom = atom(async get => {
	const apiKey = get(pendoApiKeyAtom);

	if (!apiKey) {
		return;
	}

	try {
		await pendoScript(apiKey);
	} catch (error) {
		console.error('error initializing pendo', error);
		return false;
	}
	console.debug('pendo initialized');
	return true;
});
